import dayjs from 'dayjs';
import { Tone } from './types';
import { IntlShape } from 'react-intl';
import { renderFormattedDate } from 'utils';

export const getInitials = (value?: string | null) => {
  const parts = value?.trim().split(/\s+/).filter(Boolean) || [];

  if (!parts.length) return '-';

  return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toLocaleUpperCase();
};

export const formatDateTime = (value: string | null | undefined, intl: IntlShape) =>
  value ? renderFormattedDate(value, true) : intl.formatMessage({ id: 'freshdesk.notAvailable' });

export const getDueTone = (dueBy: string | null | undefined): Tone =>
  dueBy && dayjs(dueBy).isBefore(dayjs()) ? 'error' : 'warning';

export const getStatusMeta = (status: number, intl: IntlShape, statusText?: string) => {
  switch (status) {
    case 2:
      return {
        label: intl.formatMessage({ id: 'freshdesk.status.open' }),
        tone: 'info' as Tone,
      };
    case 3:
      return {
        label: intl.formatMessage({ id: 'freshdesk.status.pending' }),
        tone: 'warning' as Tone,
      };
    case 4:
      return {
        label: intl.formatMessage({ id: 'freshdesk.status.resolved' }),
        tone: 'success' as Tone,
      };
    case 5:
      return {
        label: intl.formatMessage({ id: 'freshdesk.status.closed' }),
        tone: 'success' as Tone,
      };
    default:
      return {
        label: intl.formatMessage({ id: 'freshdesk.status.unknown' }, { status: statusText || status }),
        tone: 'primary' as Tone,
      };
  }
};

export const getPriorityMeta = (priority: number, intl: IntlShape) => {
  switch (priority) {
    case 1:
      return {
        label: intl.formatMessage({ id: 'freshdesk.priority.low' }),
        tone: 'info' as Tone,
      };
    case 2:
      return {
        label: intl.formatMessage({ id: 'freshdesk.priority.medium' }),
        tone: 'primary' as Tone,
      };
    case 3:
      return {
        label: intl.formatMessage({ id: 'freshdesk.priority.high' }),
        tone: 'warning' as Tone,
      };
    case 4:
      return {
        label: intl.formatMessage({ id: 'freshdesk.priority.urgent' }),
        tone: 'error' as Tone,
      };
    default:
      return {
        label: intl.formatMessage({ id: 'freshdesk.priority.unknown' }, { priority }),
        tone: 'primary' as Tone,
      };
  }
};
